<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>
    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          md="10"
          class="px-1"
          order="2"
          order-md="1"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_search"
              v-model="tableSwiftPay.filter.search"
              type="text"
              size="sm"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Status"
            label-for="filter_status"
            label-class="font-weight-bolder"
          >
            <b-form-select
              id="filter_status"
              v-model="tableSwiftPay.filter.status"
              size="sm"
              :options="tableSwiftPay.filterOptions.statuses"
            >
              <template #first>
                <b-form-select-option
                  :value="null"
                  disabled
                >
                  -- select status here --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableSwiftPay"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableSwiftPay.perPage"
            :current-page="tableSwiftPay.currentPage"
            :items="tableSwiftPayProvider"
            :fields="tableSwiftPay.fields"
            :sort-by.sync="tableSwiftPay.sortBy"
            :sort-desc.sync="tableSwiftPay.sortDesc"
            :sort-direction="tableSwiftPay.sortDirection"
            :filter="tableSwiftPay.filter"
            :filter-included-fields="tableSwiftPay.filterOn"
            :busy="tableSwiftPay.busy"
          >
            <template #cell(index)="row">
              {{ tableSwiftPay.currentPage * tableSwiftPay.perPage - tableSwiftPay.perPage + (row.index + 1) }}
            </template>

            <template #cell()="row">
              <div class="text-wrap text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell(amount)="row">
              <div
                class="text-md-nowrap text-right"
                style="min-width: 100px !important;"
              >
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  v-if="row.item.webhook"
                  size="sm"
                  :variant="row.detailsShowing ? 'danger' : 'primary' "
                  @click="row.toggleDetails"
                >
                  {{ row.detailsShowing ? 'Hide' : 'Show' }} Webhook
                </b-button>
              </div>
            </template>

            <template #row-details="{ item }">
              <b-form-group
                label="Payload"
                label-class="font-weight-bolder"
                class="mb-2 px-5"
              >
                <vue-json-pretty
                  :data="item.webhook"
                />
              </b-form-group>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableSwiftPay.perPage"
            :options="tableSwiftPay.pageOptions"
            size="sm"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableSwiftPay.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableSwiftPay.totalRows"
            :per-page="tableSwiftPay.perPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
// import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SAdminReport } from '@/services'
import formatter from '@/mixins/formatter'
import Ripple from 'vue-ripple-directive'
import misc from '@/mixins/misc'

export default {
  name: 'AdminReportsSwiftPay',

  middleware: ['auth', 'admin'],

  directives: {
    Ripple
  },

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'SwiftPay'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      tableSwiftPay: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null,
          status: 'All'
        },
        filterOn: [],
        filterOptions: {
          statuses: ['All', 'Pending', 'Failed', 'Rejected']
        },
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 10, key: 'action', class: 'text-center min-w-150px' },
          { mobile: 1, key: 'created_at', class: 'min-w-200px', formatter: this.dateTimeFormatter, sortable: true },
          { mobile: 2, key: 'user.organization', label: 'Organization', class: 'min-w-250px' },
          { mobile: 3, key: 'partner_reference', class: 'min-w-350px' },
          { mobile: 4, key: 'provider_reference', class: 'min-w-350px' },
          { mobile: 5, key: 'external_reference', class: 'min-w-350px' },
          { mobile: 6, key: 'amount', class: 'min-w-150px', formatter: this.numberFormatter },
          { mobile: 7, key: 'status', class: 'text-center min-w-100px' },
          { mobile: 8, key: 'paid_at', class: 'min-w-200px', formatter: this.dateTimeFormatter, sortable: true },
          { mobile: 9, key: 'tag', class: 'text-center min-w-100px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async tableSwiftPayProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableSwiftPay.busy = true
      return await SAdminReport.getSwiftPay(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tableSwiftPay.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableSwiftPay.busy = false
      })
    }
  }
}
</script>
